const defaultState = { loading: true, uid: null, error: null };

export default defaultState;
